<template>
    <div>
        <div :id="id"></div>
        <component :is="'script'" :type="type" defer :src="src"></component>
    </div>
</template>

<script>
export default {
    name: 'Tool',
    props: {
        data: Object,
    },
    data: () => {
        return {
            appType: process.env.VUE_APP_TYPE,
            schema: process.env.VUE_APP_SCHEMA,
            tloUrl: process.env.VUE_APP_TLO_URL,
        }
    },
    computed: {
        id() {
            switch (this.data.toolType) {
                case 'Selector':
                    return `thomson-${this.schema}`
                case 'Motioneering':
                    return `thomsonmotioneering-${this.schema}`
                case 'Parser':
                    return `thomsonparser-${this.schema}`
                default:
                    return ''
            }
        },

        type() {
            switch (this.data.toolType) {
                case 'Selector':
                    return 'module'
                default:
                    if (this.schema == 'lms') {
                        return 'module'
                    } else {
                        return 'application/javascript'
                    }
            }
        },

        src() {
            switch (this.data.toolType) {
                case 'Selector':
                    return `${this.tloUrl}/widgets/${this.appType}/${this.schema}/thomson.${this.schema}.js`
                case 'Motioneering':
                    return `${this.tloUrl}/widgets/${this.appType}motioneering/${this.schema}/thomsonmotioneering.${this.schema}.js`
                case 'Parser':
                    return `${this.tloUrl}/widgets/${this.appType}parser/${this.schema}/thomsonparser.${this.schema}.js`
                default:
                    return ''
            }
        },
    }
}
</script>